import { useContext, useState, useEffect } from "react";

import { AppContexts } from "../../providers";

import MainBody from "../common/MainBody";
import UpdatePasswordForm from "./forms/update-password";
import UpdateEmailForm from "./forms/update-email";
import UpdateImageForm from "./forms/update-profile-image";
import UpdateSmsSignatureForm from "./forms/update-sms-signature";

const Profile = () => {
  useEffect(() => {
    document.title = "Profile - RueBaRue";
  }, []);

  return (
    <>
      <MainBody id="hms-profile-settings-template" title="Profile">
        <div className="profile-setting-left">
          <div className="uk-card hms-left-tabs-content-card mx-w-665 uk-margin-bottom">
            <div className="profile-form">
              <div className="uk-width-1-1 uk-margin-bottom hms-headings">
                <h3 className="uk-margin-small-bottom">Profile Picture</h3>
              </div>

              <UpdateImageForm />
            </div>
          </div>

          <div className="uk-card hms-left-tabs-content-card mx-w-665 uk-margin-bottom">
            <div className="profile-form">
              <div className="uk-width-1-1 uk-margin-bottom hms-headings">
                <h3 className="uk-margin-small-bottom">Manual Text Reply Signature</h3>
              </div>

              <UpdateSmsSignatureForm />
            </div>
          </div>

          <div className="uk-card hms-left-tabs-content-card mx-w-665 uk-margin-bottom">
            <div className="profile-form">
              <div className="uk-width-1-1 uk-margin-bottom hms-headings">
                <h3 className="uk-margin-small-bottom">Update Email</h3>
              </div>

              <UpdateEmailForm />
            </div>
          </div>

          <div className="uk-card hms-left-tabs-content-card mx-w-665">
            <div className="profile-form">
              <div className="uk-width-1-1 uk-margin-bottom hms-headings">
                <h3 className="uk-margin-small-bottom">Update Password</h3>
              </div>

              <UpdatePasswordForm />
            </div>
          </div>
        </div>
      </MainBody>
    </>
  );
};

export default Profile;
